import React from 'react';
import { DosagePattern } from '@/types/medication';
import { WizardMedication } from '@/types/wizard';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface DosagePatternSelectProps {
  medication: WizardMedication;
  onChange: (medication: WizardMedication) => void;
}

export const DosagePatternSelect = ({ medication, onChange }: DosagePatternSelectProps) => {
  const renderDosagePatternFields = () => {
    if (medication.isPRN) return null;

    switch (medication.dosagePattern) {
      case 'every-x-hours':
        return (
          <div className="mt-4">
            <label className="block text-sm font-medium mb-2">Hours between doses</label>
            <Input
              type="number"
              min="1"
              max="72"
              value={medication.customInterval}
              onChange={(e) => onChange({ 
                ...medication, 
                customInterval: parseInt(e.target.value) 
              })}
              className="w-full bg-white"
            />
          </div>
        );
      case 'cyclical':
        return (
          <div className="mt-4 space-y-4">
            <div>
              <label className="block text-sm font-medium mb-2">Days ON medication</label>
              <Input
                type="number"
                min="1"
                max="30"
                value={medication.cycleDays?.on}
                onChange={(e) => onChange({
                  ...medication,
                  cycleDays: { ...medication.cycleDays!, on: parseInt(e.target.value) }
                })}
                className="w-full bg-white"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">Days OFF medication</label>
              <Input
                type="number"
                min="1"
                max="30"
                value={medication.cycleDays?.off}
                onChange={(e) => onChange({
                  ...medication,
                  cycleDays: { ...medication.cycleDays!, off: parseInt(e.target.value) }
                })}
                className="w-full bg-white"
              />
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Select
        value={medication.dosagePattern}
        onValueChange={(value: DosagePattern) => 
          onChange({ ...medication, dosagePattern: value })
        }
      >
        <SelectTrigger 
          className="w-full bg-white"
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => e.stopPropagation()}
        >
          <SelectValue placeholder="Select dosage pattern" />
        </SelectTrigger>
        <SelectContent className="bg-white z-50 shadow-lg border rounded-lg">
          <SelectItem value="daily">Once daily</SelectItem>
          <SelectItem value="twice-daily">Twice daily</SelectItem>
          <SelectItem value="every-x-hours">Every X hours</SelectItem>
          <SelectItem value="weekly">Weekly</SelectItem>
          <SelectItem value="monthly">Monthly</SelectItem>
          <SelectItem value="cyclical">Cyclical (Days on/off)</SelectItem>
          <SelectItem value="custom">Custom</SelectItem>
        </SelectContent>
      </Select>
      {renderDosagePatternFields()}
    </>
  );
};